__turbopack_context__.v({
  "body": "careers-intro-module-scss-module__2gknKW__body",
  "cta": "careers-intro-module-scss-module__2gknKW__cta",
  "eyebrow": "careers-intro-module-scss-module__2gknKW__eyebrow",
  "heading": "careers-intro-module-scss-module__2gknKW__heading",
  "intro": "careers-intro-module-scss-module__2gknKW__intro",
});
